import React, { Component } from "react";
import {
  Button, Card, CardBody, CardHeader, Col, Row,
  ButtonToolbar, ButtonGroup
} from "reactstrap";
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";

import LoadingIcon from "mdi-react/LoadingIcon";
import SettingsIcon from "mdi-react/SettingsIcon";
import {
  loadComponentType,
  loadComponents,
  openComponent,
  deleteComponent,
} from "../../../../../redux/actions/componentActions";
import DeletePopUP from "../../../../../shared/components/deletePopUp";

export class ComponentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      showDeleteAlert: false,
      selectedComponent: null,
    };
  }

  componentWillMount() {
    const { selectedAsset, loadComponents, loadComponentType } = this.props;
    const parent_asset_id = selectedAsset && selectedAsset._id;
    loadComponentType();
    loadComponents({parent_asset_id});
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.components){
      this.setState ({
        dataLoaded:true,
        formType: null,
        showDeleteAlert: false,
        selectedComponent:null
      });
    }
  };

  openForm = (type, selectedComponent) => {
    if (selectedComponent){
      selectedComponent["formType"]= type;
      this.props.openComponent(selectedComponent);
    } else{
      this.props.openComponent(null);
    }

    this.props.history.push("/settings/assets_management/create_update_component");
  };

  renderActionButtons = (cell, row) => {
    return (
      <div className="text-center">
        <ButtonToolbar>
          <ButtonGroup className="btn-group--icons" dir="ltr">
            <Button
              outline color="success"
              onClick={() => this.openForm("update", row)}
            >
              <span className="lnr lnr-pencil" />
            </Button>
            <Button
              outline color="warning"
              onClick={() => this.openForm("clone", row)}
            >
              <span className="lnr lnr-plus-circle" />
            </Button>
            <Button
              outline color="danger"
              onClick={() =>
                this.setState({
                  showDeleteAlert: true,
                  selectedComponent: row
                })
              }
            >
              <span className="lnr lnr-cross" />
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    );
  };

  renderActionButton2 = props => {
    return (
      <div className="text-right">
        <Button
          className="icon rm-m-b"
          color="primary"
          onClick={() => this.openForm("create")}
        >
          <p><SettingsIcon /> New Component</p>
        </Button>
      </div>
    );
  };

  render () {
    const { dataLoaded, showDeleteAlert, selectedComponent } = this.state;
    const { components, deleteComponent, t } = this.props;
    const options = {
      searchPosition: 'left',
      btnGroup: this.renderActionButton2
    };

    return (
      <React.Fragment>
        {
          !dataLoaded &&
          <Row>
            <Card>
              <CardHeader>
                <div className="form__form-group-icon">
                  <LoadingIcon />
                </div>
                Loading Component
              </CardHeader>
              <CardBody>
                <div></div>
              </CardBody>
            </Card>
          </Row>
        }

        {
          dataLoaded &&
          <Row>
            <Col md={12}>
              <Card>
                <CardHeader >
                  {t('asset_management.component_title')}
                </CardHeader>
                <CardBody>
                  <BootstrapTable
                    options={options}
                    data={components}
                    version="4"
                    bordered={false}
                    striped pagination search
                  >
                    <TableHeaderColumn dataField="component_name" dataSort>
                      {t('asset_management.component_label.component_name')}
                    </TableHeaderColumn>
                    <TableHeaderColumn width="160" dataField="component_type_name">
                      {t('asset_management.component_label.component_type_name')}
                    </TableHeaderColumn>
                    <TableHeaderColumn width="160" dataField="updated_health_status">
                      {t('asset_management.component_label.health_status')}
                    </TableHeaderColumn>
                    <TableHeaderColumn width="160" dataField="data_status">
                      {t('asset_management.component_label.data_status')}
                    </TableHeaderColumn>
                    <TableHeaderColumn isKey dataField="_id" dataSort hidden={true}>
                      Id
                    </TableHeaderColumn>
                    <TableHeaderColumn
                      width="160"
                      dataField="_id"
                      dataFormat={this.renderActionButtons}
                    >
                      {t('asset_management.component_label.action')}
                    </TableHeaderColumn>

                  </BootstrapTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        }

        <DeletePopUP
          title="Are you sure, you want to delete this Asset?"
          showDeleteAlert={ showDeleteAlert }
          onDelete={() => {
            deleteComponent(selectedComponent);
            return this.setState({ showDeleteAlert: false });
          }}
          onCancel={() => this.setState({ showDeleteAlert: false })
          }
        />

      </React.Fragment>
    );
  }
}

ComponentList.propTypes = {
  t: PropTypes.func.isRequired,
  loadComponents: PropTypes.func.isRequired,
  openComponent: PropTypes.func.isRequired,
  deleteComponent: PropTypes.func.isRequired,
  components: PropTypes.array,
  selectedComponent: PropTypes.any,
  selectedAsset: PropTypes.any,
};

function mapStateToProps({ component }) {
  return {
    components: component.components,
    selectedComponent: component.selectedComponent,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      loadComponents,
      loadComponentType,
      openComponent,
      deleteComponent,
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(ComponentList)
);
